import React from 'react' // eslint-disable-line no-unused-vars
import { connect } from 'react-redux'
import { LINK_BUTTON, NO_NAME_DISPLAYED } from '../../constants'
import DownloadableDocumentsTable from '../tables/DownloadableDocumentsTable'

const PRESCRIBING_INFO = 'prescribingInformationList'
const MEDICATION_GUIDES = 'medicationGuideList'
const DIRECTIONS = 'directionsAndInstructionsForUse'
const SAFETY_INFORMATION = 'importantSafetyInformationList'
const PATIENT_LABELING = 'patientLabelingList'
const DRUG_FACTS = 'drugFactsList'

const ProductDocumentation = ({ pageContent, product, showMobileVersion }) => {
    const languageContent = pageContent.content.module.products.details
    const columnNames = [
        languageContent.type,
        languageContent.versionLanguage,
        NO_NAME_DISPLAYED
    ]

    // Keys that identify data elements to include in the table columns,
    // with associated formatting
    const columnKeys = [
        {
            key: 'type',
            style: { fontWeight: 'bold' },
            width: '45%'
        },
        {
            key: 'version',
            groupedTableStyle: { borderTop: '1px solid #d6d6d6' },
            width: '30%'
        },
        {
            key: LINK_BUTTON,
            style: { textAlign: 'right' },
            groupedTableStyle: { borderTop: '1px solid #d6d6d6' },
            width: '25%'
        }
    ]

    // Convert product docs to format consumable by DownloadableDocumentsTable.js
    const formattedDocuments = formatProductDocumentation(product, languageContent)

    return (
        <React.Fragment>
            <h3 className='section-header'>
                {languageContent.documentation}
            </h3>
            <DownloadableDocumentsTable
                id='documentation'
                items={formattedDocuments}
                columnNames={columnNames}
                columnKeys={columnKeys}
                showMobileVersion={showMobileVersion}
            />
        </React.Fragment>
    )}

const formatProductDocumentation = (product, languageContent) => {
    const documents = []
    const prescribingInfoDocs = product[PRESCRIBING_INFO]
    if (prescribingInfoDocs && prescribingInfoDocs.length > 0) {
        documents.push(formatGroupedDocs(prescribingInfoDocs, languageContent.prescribingInformation))
    }
    const medicationGuides = product[MEDICATION_GUIDES]
    if (medicationGuides && medicationGuides.length > 0) {
        documents.push(formatGroupedDocs(medicationGuides, languageContent.medicationGuide))
    }
    const directionsInstructions = product[DIRECTIONS]
    if (directionsInstructions && directionsInstructions.length > 0) {
        documents.push(formatGroupedDocs(directionsInstructions, languageContent.instructionsDirectionsForUse))
    }
    const safetyInfoDocs = product[SAFETY_INFORMATION]
    if (safetyInfoDocs && safetyInfoDocs.length > 0) {
        documents.push(formatGroupedDocs(safetyInfoDocs, languageContent.importantSafetyInformation))
    }
    const patientLabelingDocs = product[PATIENT_LABELING]
    if (patientLabelingDocs && patientLabelingDocs.length > 0) {
        documents.push(formatGroupedDocs(patientLabelingDocs, languageContent.patientLabeling))
    }
    const drugFacts = product[DRUG_FACTS]
    if (drugFacts && drugFacts.length > 0) {
        documents.push(formatGroupedDocs(drugFacts, languageContent.drugFacts))
    }
    return documents
}

const formatGroupedDocs = (documents, header) => ({
        groupedCardStyle: {  borderTop: '1px solid #d6d6d6', paddingTop: '30px'},
        groupedDocuments: documents.map((doc, i) => ({
            applyGroupedTableStyle: i !== 0,
            parent: {
                type: i === 0 ? header : NO_NAME_DISPLAYED,
                ...doc
            }
        }))
    })

const mapStateToProps = state => ({
    pageContent: state.pageContent,
  })

export default connect(mapStateToProps)(ProductDocumentation)


// WEBPACK FOOTER //
// ./src/mi-app/products/ProductDocumentation.js